import { faAngleDown, faAngleUp, faAward, faBriefcase, faChartPie, faCog, faFile, faFileContract, faFileInvoice, faFileWaveform, faHouse, faIdBadge, faList, faLocationDot, faNewspaper, faRightFromBracket, faUsers, faClipboardList } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import SwalServices from '../../services/swalServices/SwalServices';
import AdminServices from '../../services/axiosServices/apiServices/adminServices';
import { getAuthProps, signOut } from '../../utils/AuthenticationLibrary';
import { removeAllCookies } from '../../utils/cookies/CookieHandler';
import { Value3, Value4 } from '../../utils/AppSetting';

export default class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.swalServices = new SwalServices();
    this.adminServices = new AdminServices();
    this.state = {
      isLoading: false,
      roleId: 0,
    };
  }

  componentDidMount() {
    let cookie = getAuthProps();
    const roleId = cookie && cookie.roleId ? Number(cookie.roleId) : 0;
    if (roleId > 0) {
      this.setState({ roleId: roleId });
    }
  }

  userLogout = () => {
    this.setState({ isLoading: true });
    this.adminServices.userLogout().then((response) => {
      if (response.success === 1) {
        // Clear all cookies
        removeAllCookies();

        // Clear all localStorage items
        localStorage.removeItem('APToken');
        localStorage.removeItem(Value3);
        localStorage.removeItem(Value4);
        localStorage.removeItem('Token101');
        localStorage.removeItem('AuthUserWeb101');
        localStorage.removeItem('homeAccountId');
        localStorage.clear();

        window.location.href = "/login";
      } else {
        this.swalServices.Error(response.msg)
      }
      this.setState({ isLoading: false });
    });
  }

  toggleExpand = () => {
    this.setState((prevState) => ({
      isExpand: !prevState.isExpand,
    }));
  };

  render() {
    return (
      <div className='sidebar w-[210px] h-screen bg-white'
        style={{ boxShadow: "7px 0px 12px -6px rgba(14, 63, 126, 0.4)", borderRight: "1px solid rgba(34,54,69,0.1)", height: "calc(100dvh / 0.85)" }}
      >
        <div className='sidebar-inner h-full'>
          <div className='sidebar-logo p-[15px] h-[85px]'>
            <a href='https://arbourhealthcaregroup.co.uk/' target='_blank' rel='noreferrer'>
              <img src='AHG-logo.svg' alt='Arbour Health Group' className='w-[auto] h-[55px]' />
            </a>
          </div>
          <div className='sidebar-links h-full p-5 flex flex-col justify-between rounded-t-[10px] bg-[#004AAD] overflow-hidden'
            style={{ height: "calc((100dvh / 0.85) - 85px)" }}
          >
            <div className='page-links grid gap-[5px] page-links overflow-y-auto' style={{ maxHeight: "calc((100dvh / 0.85) - 85px - 90px)", scrollbarWidth: "none", msOverflowStyle: "none", }}>
              {this.state.roleId === 3 ? (
                <NavLink to="/visitor-reports" className="text-white hover:text-[#223645] no-underline rounded-[16px] hover:bg-[#97D6FF]" onClick={() => this.setState({ isExpand: false })}>
                  <div className='page-link flex items-center gap-[10px] p-[8.5px]'>
                    <FontAwesomeIcon className='w-[20px] h-[20px]' icon={faClipboardList} />
                    <span className='text-[14px] font-medium'>Visitor Reports</span>
                  </div>
                </NavLink>
              ) : (
              <>
              <NavLink to="/dashboard" className="text-white hover:text-[#223645] no-underline  rounded-[16px] hover:bg-[#97D6FF]" onClick={() => this.setState({ isExpand: false })}>
                <div className='page-link  flex items-center gap-[10px] p-[8.5px]'>
                  <FontAwesomeIcon className='w-[20px] h-[20px]' icon={faChartPie} />
                  <span className='text-[14px] font-medium'>Dashboard</span>
                </div>
              </NavLink>
              {/* User Profile - Super Admin only */}
              {this.state.roleId === 1 ?
                <NavLink to="/users-list" className="text-white hover:text-[#223645] no-underline rounded-[16px] hover:bg-[#97D6FF]" onClick={() => this.setState({ isExpand: false })}>
                  <div className='page-link  flex items-center gap-[10px] p-[8.5px] rounded-[16px] hover:bg-[#97D6FF]'>
                    <FontAwesomeIcon className='w-[20px] h-[20px]' icon={faIdBadge} />
                    <span className='text-[14px] font-medium'>User profile</span>
                  </div>
                </NavLink>
                : null}
              {/* Content Management - Super Admin only (roleId 1) */}
              {(this.state.roleId === 1) && (
                <>
                  <NavLink to="/jobs" className="text-white hover:text-[#223645] no-underline rounded-[16px] hover:bg-[#97D6FF]" onClick={() => this.setState({ isExpand: false })}>
                    <div className='page-link  flex items-center gap-[10px] p-[8.5px]'>
                      <FontAwesomeIcon className='w-[20px] h-[20px]' icon={faBriefcase} />
                      <span className='text-[14px] font-medium'>Jobs</span>
                    </div>
                  </NavLink>
                  <NavLink to="/blogs" className="text-white hover:text-[#223645] no-underline rounded-[16px] hover:bg-[#97D6FF]" onClick={() => this.setState({ isExpand: false })}>
                    <div className='page-link  flex items-center gap-[10px] p-[8.5px]'>
                      <FontAwesomeIcon className='w-[20px] h-[20px]' icon={faNewspaper} />
                      <span className='text-[14px] font-medium'>News/Blogs</span>
                    </div>
                  </NavLink>
                  <NavLink to="/locations" className="text-white hover:text-[#223645] no-underline rounded-[16px] hover:bg-[#97D6FF]" onClick={() => this.setState({ isExpand: false })}>
                    <div className='page-link  flex items-center gap-[10px] p-[8.5px]'>
                      <FontAwesomeIcon className='w-[20px] h-[20px]' icon={faLocationDot} />
                      <span className='text-[14px] font-medium'>Locations</span>
                    </div>
                  </NavLink>
                  <NavLink to="/form-list" className="text-white hover:text-[#223645] no-underline rounded-[16px] hover:bg-[#97D6FF]" onClick={() => this.setState({ isExpand: false })}>
                    <div className='page-link  flex items-center gap-[10px] p-[8.5px]'>
                      <FontAwesomeIcon className='w-[20px] h-[20px]' icon={faFileWaveform} />
                      <span className='text-[14px] font-medium'>Forms</span>
                    </div>
                  </NavLink>
                  <NavLink to="/policy" className="text-white hover:text-[#223645] no-underline rounded-[16px] hover:bg-[#97D6FF]" onClick={() => this.setState({ isExpand: false })}>
                    <div className='page-link  flex items-center gap-[10px] p-[8.5px]'>
                      <FontAwesomeIcon className='w-[20px] h-[20px]' icon={faFileContract} />
                      <span className='text-[14px] font-medium'>Policy</span>
                    </div>
                  </NavLink>
                  <NavLink to="/eom" className="text-white hover:text-[#223645] no-underline rounded-[16px] hover:bg-[#97D6FF]" onClick={() => this.setState({ isExpand: false })}>
                    <div className='page-link  flex items-center gap-[10px] p-[8.5px]'>
                      <FontAwesomeIcon className='w-[20px] h-[20px]' icon={faAward} />
                      <span className='text-[14px] font-medium'>EOM</span>
                    </div>
                  </NavLink>
                  <NavLink to="/configuration" className="text-white hover:text-[#223645] no-underline rounded-[16px] hover:bg-[#97D6FF]" onClick={() => this.setState({ isExpand: false })}>
                    <div className='page-link  flex items-center gap-[10px] p-[8.5px]'>
                      <FontAwesomeIcon className='w-[20px] h-[20px]' icon={faCog} />
                      <span className='text-[14px] font-medium'>Configuration</span>
                    </div>
                  </NavLink>
                  <NavLink to="/house-master" className="text-white hover:text-[#223645] no-underline rounded-[16px] hover:bg-[#97D6FF]" onClick={() => this.setState({ isExpand: false })}>
                    <div className='page-link  flex items-center gap-[10px] p-[8.5px]'>
                      <FontAwesomeIcon className='w-[20px] h-[20px]' icon={faHouse} />
                      <span className='text-[14px] font-medium'>House Master</span>
                    </div>
                  </NavLink>
                </>
              )}
              <div
                className={`expand-option no-underline rounded-[16px] cursor-pointer p-[10px] ${this.state.isExpand
                  ? 'bg-[#FFFFFF] text-[#223645]'
                  : 'text-white hover:text-[#223645] hover:bg-[#97D6FF]'
                  }`}
              >
                <div className={`expand-option-inner flex items-center justify-between gap-[10px] ${this.state.isExpand ? "mb-[10px]" : "mb-0"}`} onClick={this.toggleExpand}>
                  <p className='text-[14px] font-medium flex items-center gap-[10px] m-0'><FontAwesomeIcon className='w-[20px] h-[20px]' icon={faFileInvoice} />Reports</p>
                  <FontAwesomeIcon icon={this.state.isExpand ? faAngleUp : faAngleDown} className='w-[15px] h-[15px]' />
                </div>
                {this.state.isExpand === true &&
                  (
                    <div className='expand-menu grid gap-[5px]'>
                      {this.state.roleId === 1 ?
                        <NavLink to="/subscribers-list" className="text-[#004aad] hover:text-[#223645] no-underline">
                          <div className='page-link flex items-center gap-[10px] p-[8.5px] hover:bg-[#97D6FF] rounded-[16px]'>
                            <FontAwesomeIcon className='w-[20px] h-[20px]' icon={faUsers} />
                            <span className='text-[14px] font-medium'>Subscribers</span>
                          </div>
                        </NavLink>
                        : null}
                      <NavLink to="/cv-list" className="text-[#004aad] hover:text-[#223645] no-underline">
                        <div className='page-link  flex items-center gap-[10px] p-[8.5px] hover:bg-[#97D6FF] rounded-[16px]'>
                          <FontAwesomeIcon className='w-[20px] h-[20px]' icon={faFile} />
                          <span className='text-[14px] font-medium'>CV list</span>
                        </div>
                      </NavLink>
                      <NavLink to="/submitted-forms" className="text-[#004aad] hover:text-[#223645] no-underline">
                        <div className='page-link  flex items-center gap-[10px] p-[8.5px] hover:bg-[#97D6FF] rounded-[16px]'>
                          <FontAwesomeIcon className='w-[20px] h-[20px]' icon={faFile} />
                          <span className='text-[14px] font-medium'>Submitted Forms</span>
                        </div>
                      </NavLink>
                      <NavLink to="/eom-submissions" className="text-[#004aad] hover:text-[#223645] no-underline">
                        <div className='page-link  flex items-center gap-[10px] p-[8.5px] hover:bg-[#97D6FF] rounded-[16px]'>
                          <FontAwesomeIcon className='w-[20px] h-[20px]' icon={faAward} />
                          <span className='text-[14px] font-medium'>EOM Submissions</span>
                        </div>
                      </NavLink>
                      <NavLink to="/timesheet-expense" className="text-[#004aad] hover:text-[#223645] no-underline">
                        <div className='page-link  flex items-center gap-[10px] p-[8.5px] hover:bg-[#97D6FF] rounded-[16px]'>
                          <FontAwesomeIcon className='w-[20px] h-[20px]' icon={faFile} />
                          <span className='text-[14px] font-medium'>Timesheet / Expense</span>
                        </div>
                      </NavLink>
                      <NavLink to="/timesheet-details" className="text-[#004aad] hover:text-[#223645] no-underline">
                        <div className='page-link  flex items-center gap-[10px] p-[8.5px] hover:bg-[#97D6FF] rounded-[16px]'>
                          <FontAwesomeIcon className='w-[20px] h-[20px]' icon={faFile} />
                          <span className='text-[14px] font-medium'>Timesheet Details</span>
                        </div>
                      </NavLink>
                      <NavLink to="/safeguarding-form" className="text-[#004aad] hover:text-[#223645] no-underline">
                        <div className='page-link  flex items-center gap-[10px] p-[8.5px] hover:bg-[#97D6FF] rounded-[16px]'>
                          <FontAwesomeIcon className='w-[20px] h-[20px]' icon={faFile} />
                          <span className='text-[14px] font-medium'>Safeguarding</span>
                        </div>
                      </NavLink>
                      <NavLink to="/inquiry-report" className="text-[#004aad] hover:text-[#223645] no-underline">
                        <div className='page-link  flex items-center gap-[10px] p-[8.5px] hover:bg-[#97D6FF] rounded-[16px]'>
                          <FontAwesomeIcon className='w-[20px] h-[20px]' icon={faFile} />
                          <span className='text-[14px] font-medium'>Inquiry / Referral</span>
                        </div>
                      </NavLink>
                      {(this.state.roleId === 1 || this.state.roleId === 2) &&
                        <NavLink to="/visitor-reports" className="text-[#004aad] hover:text-[#223645] no-underline">
                          <div className='page-link flex items-center gap-[10px] p-[8.5px] hover:bg-[#97D6FF] rounded-[16px]'>
                            <FontAwesomeIcon className='w-[20px] h-[20px]' icon={faFile} />
                            <span className='text-[14px] font-medium'>Visitor Reports</span>
                          </div>
                        </NavLink>
                      }
                      {this.state.roleId === 1 ?
                        <NavLink to="/user-logs" className="text-[#004aad] hover:text-[#223645] no-underline">
                          <div className='page-link  flex items-center gap-[10px] p-[8.5px] hover:bg-[#97D6FF] rounded-[16px]'>
                            <FontAwesomeIcon className='w-[20px] h-[20px]' icon={faList} />
                            <span className='text-[14px] font-medium'>User logs</span>
                          </div>
                        </NavLink>
                        : null}
                    </div>
                  )
                }
              </div>
              </>
              )}
            </div>
            <div className='logout-link '>
              <button
                className='flex items-center gap-[10px] text-[14px] font-medium bg-white hover:bg-[#97D6FF] border-0 rounded-[16px] p-[10px] w-full'
                onClick={() => this.userLogout()}
              >
                <FontAwesomeIcon
                  className='w-[20px] h-[20px]'
                  icon={faRightFromBracket}
                />
                Logout
              </button>
            </div>
          </div>
        </div>
      </div >
    )
  }
}
